<template>
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block"
       @click.self="close"
       @keyup.esc="close">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content shadow-lg border-0">
        <div class="modal-header border-0 px-4 bg-primary-light">
          <h5 class="modal-title">Available Integrations for Mantiq</h5>
          <button @click="close" type="button" class="btn-close"></button>
        </div>
        <div class="modal-body p-0">
          <div class="border-top row g-0 p-4">
            <div class="col-4 pe-4">
              <img class="ratio ratio-1x1"
                   src="https://ps.w.org/mantiq-integration-for-woocommerce/assets/icon-256x256.png" alt="WooCommerce">
            </div>
            <div class="col">
              <h4>WooCommerce</h4>
              <p class="text-muted">Automate your WooCommerce shop using different actions and events.</p>
              <a rel="noopener" target="_blank" href="https://wordpress.org/plugins/mantiq-integration-for-woocommerce"
                 class="btn btn-sm btn-outline-primary">Get <span class="material-icons ms-1">open_in_new</span></a>
            </div>
          </div>
          <div class="border-top row g-0 p-4">
            <div class="col-4 pe-4">
              <img class="ratio ratio-1x1"
                   src="https://ps.w.org/mantiq-integration-for-slack/assets/icon-256x256.png" alt="Slack">
            </div>
            <div class="col">
              <h4>Slack</h4>
              <p class="text-muted">Send messages from your workflows to your Slack channels.</p>
              <a rel="noopener" target="_blank" href="https://wordpress.org/plugins/mantiq-integration-for-slack"
                 class="btn btn-sm btn-outline-primary">Get <span class="material-icons ms-1">open_in_new</span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div hidden class="position-absolute top-0 end-0 bottom-0 start-0 bg-white" @keyup.esc="close">
    <button class="btn border btn-inline p-2 rounded-circle position-absolute top-0 end-0 m-3" @click="close">
      <span class="material-icons">close</span>
    </button>
    <div class="container p-5">
      <div class="row justify-content-center">
        <div class="col-8">
          <h3 class="mb-5 pb-3 border-bottom">What's New in Mantiq</h3>
          <h6 class="mb-3">November 2021</h6>
          <div class="row mb-3">
            <div class="col-2 text-end border-end"><strong>New</strong></div>
            <div class="col">
              <p>WooCommerce integration. Now you can automate your WooCommerce shop using different events and
                actions.</p>
              <p>Filter log by type.</p>
              <p>Encode output as JSON string and write to log actions for developers.</p>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-2 text-end border-end"><strong>Improvements</strong></div>
            <div class="col">
              <p>Underlaying APIs to enable more integrations and support more use cases.</p>
              <p>Error messages are more clear now.</p>
              <p>Encode output as JSON string and write to log actions for developers.</p>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-2 text-end border-end"><strong>Fixes</strong></div>
            <div class="col">
              <p></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useRouter} from "vue-router";

export default {
  name: "Integrations",
  setup() {
    const router = useRouter();

    const close = () => {
      router.push({path: '../'});
    };

    return {
      close,
    };
  }
}
</script>
